import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-search\"><defs><style type=\"text/css\"></style></defs><path d=\"M485.376 238.933333A239.388444 239.388444 0 1 0 724.764444 477.866667a239.616 239.616 0 0 0-239.388444-238.933334z m0 444.643556a204.8 204.8 0 1 1 204.8-204.8 204.8 204.8 0 0 1-204.8 203.889778z\" p-id=\"2511\" fill=\"#767676\" /><path d=\"M403.456 344.519111a155.875556 155.875556 0 0 0-75.093333 133.347556 17.066667 17.066667 0 0 0 34.133333 0 121.969778 121.969778 0 0 1 58.709333-104.675556 17.066667 17.066667 0 0 0-17.749333-28.672zM773.688889 755.939556l-78.279111-78.279112a17.066667 17.066667 0 0 0-24.120889 24.120889l78.279111 78.279111A17.066667 17.066667 0 1 0 773.688889 755.939556z\" p-id=\"2512\" fill=\"#767676\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/search.svg
// module id = Bx0U
// module chunks = 8